// import MicroModal from 'micromodal';
import SmoothScroll from "smooth-scroll";
import { domReady } from './_dom_utils';
// import { MICRO_MODAL_CONFIG } from './_constants';


domReady(() => {
  // MicroModal.init(MICRO_MODAL_CONFIG);
  (window as any).smoothScroll = new SmoothScroll("[data-smooth-scroll]", {
    speed: 500,
    speedAsDuration: true,
    offset: 60,
    updateURL: false,
  });
});
